import { createContext } from 'react';

const professionalContext = createContext();
export default professionalContext;
